import getDisplayItemsList from "./getDisplayItemsList";
import getDisplayItemsOfSuperTypes from "./getDisplayItemsOfSuperTypes";
import getDisplayItemsOfType from "./getDisplayItemsOfType";
import getDisplayItemsWithTextSizeList from "./getDisplayItemsWithTextSizeList";
// import getDisplayItemsWithTextSizeMap from "./getDisplayItemsWithTextSizeMap";
import getSelectedDisplayItems from "./getSelectedDisplayItems";

export const displayItemSelectors = {
  // getDisplayItemsWithTextSizeMap,
  getDisplayItemsList,
  getDisplayItemsWithTextSizeList,
  getDisplayItemsOfType,
  getDisplayItemsOfSuperTypes,
  getSelectedDisplayItems
};
